import { prepareHeaders } from "./";
import cincolabdataEndpoints from "./cincolabdata.endpoints";

interface ActivationData {
  email: string;
  answers: Record<string, string | number | boolean>;
  locale: "en" | "fr";
}

/**
 * Submits an activation to the API
 * @returns Returns a promise that resolves with the email
 */
// Hidden A127 LANGUAGE field: English -> "C", French -> "B".
// Q127 is its paired hidden marker field and expects the constant "0127".
const LANGUAGE_ANSWER: Record<"en" | "fr", string> = {
  en: "C",
  fr: "B",
};

export const submitActivation = async ({
  email,
  answers,
  locale,
}: ActivationData): Promise<string> => {
  try {
    const response = await fetch(
      cincolabdataEndpoints.public.form(import.meta.env.VITE_FORM_INSTANCE_KEY),
      {
        method: "POST",
        headers: prepareHeaders(),
        mode: "cors",
        body: JSON.stringify({
          email: email.toLowerCase().trim(),
          answers: {
            ...answers,
            Q127: "0127",
            "A127 LANGUAGE": LANGUAGE_ANSWER[locale],
          },
        }),
        redirect: "follow",
      },
    );

    const data = await response.json().catch(() => ({}));
    if (response.status !== 200) {
      throw new Error(
        `Failed to create activation: ${data.error ?? data.message ?? `HTTP ${response.status}`}`,
      );
    }

    return data.email;
  } catch (error) {
    throw new Error(
      `SubmitActivation: Failed to create activation. ${(error as Error).message}`,
    );
  }
};
